import HelpBand from '../components/HelpBand';
import Icon from '../components/Icon';
import PageHero from '../components/PageHero';
import { disclaimer, site } from '../config';
import { stats } from '../data';

const values = [
  {
    title: 'Patience first',
    body: 'Many of our customers have decades of research in one file. We slow down, explain, and never rush a fix.',
  },
  {
    title: 'Backups before changes',
    body: 'Every session starts with a fresh backup so your tree is safe no matter what happens next.',
  },
  {
    title: 'Plain-English steps',
    body: 'We tell you exactly what to click and why, so you can handle it yourself next time.',
  },
];

export default function About() {
  return (
    <>
      <PageHero title="About Us">
        {site.domain} is an independent help desk for people who use Family Tree Maker to record their family
        history.
      </PageHero>

      <section className="section">
        <div className="wrap split">
          <div className="section-head section-head-left">
            <p className="eyebrow">Who we are</p>
            <h2>Technical help with a genealogist’s patience</h2>
            <p>
              Our agents work with Family Tree Maker every day on Windows and Mac. We help with installs, upgrades,
              sync, TreeVault, media links, and moving trees to a new computer — over live chat or by phone.
            </p>
            <p>
              We are not the software publisher and we do not sell licences. Our job is simply to help you get the
              software working and keep your research safe.
            </p>
          </div>
          <div className="stats-grid stats-grid-card">
            {stats.map((stat) => (
              <div key={stat.label} className="stat">
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-paper">
        <div className="wrap">
          <div className="section-head">
            <p className="eyebrow">How we work</p>
            <h2>What you can expect from us</h2>
          </div>
          <div className="card-grid card-grid-3">
            {values.map((value) => (
              <article key={value.title} className="card">
                <span className="card-icon">
                  <Icon name="check" />
                </span>
                <h3>{value.title}</h3>
                <p>{value.body}</p>
              </article>
            ))}
          </div>
          <p className="note-box">{disclaimer}</p>
        </div>
      </section>

      <HelpBand />
    </>
  );
}
